import { render } from "./LogicFlowNodeMessage.vue?vue&type=template&id=3ff9fca6"
import script from "./LogicFlowNodeMessage.vue?vue&type=script&lang=js"
export * from "./LogicFlowNodeMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/common/sys/process/logicFlow/atom/LogicFlowNodeMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ff9fca6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ff9fca6', __exports__)) {
    api.reload('3ff9fca6', __exports__)
  }
  
  module.hot.accept("./LogicFlowNodeMessage.vue?vue&type=template&id=3ff9fca6", () => {
    api.rerender('3ff9fca6', render)
  })

}


export default __exports__